module.exports = __webpack_public_path__ + "media/CYQ.1eb2aea1.mp4";